import axios from 'axios';
import { generateUrl } from '../helper';
const interview = axios.create({
    baseURL: generateUrl('user_backend'),
});

interview.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem('token');
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

interview.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default interview;
